<template>
  <div class="container text-center" id="main">
    <!-- <h3 class="mainHeader">You have signed out of <img src="../assets/images/myhr-logo.png" alt="My HR" style="margin-left: 5px;" /></h3> -->
    <div class="row">
      <div class="col-sm-12 message">
        <p>
            Please close your browser to sign out of myHR session
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'signout',
  data () {
    return { }
  }
}
</script>

<style scoped>
  #main .row {
    margin-left: 20px;
  }

  .message {
    padding: 50px 0;
  }
</style>
